import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'pr.events.viewMode';

/**
 * GRID / LIST preference for the event browse surfaces (featured wall's ALL
 * EVENTS section and /events/all).
 *
 * Persisted per user in localStorage so the choice survives navigation.
 * Default is LIST — the dense row view (design handoff, Aug 31 2026).
 * Switching modes is pure presentation: it never refetches.
 */
export default function useEventViewMode(defaultMode = 'list') {
  const [mode, setModeState] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved === 'grid' || saved === 'list' ? saved : defaultMode;
    } catch {
      return defaultMode;
    }
  });

  const setMode = useCallback((next) => {
    setModeState(next === 'grid' ? 'grid' : 'list');
  }, []);

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, mode); } catch { /* storage disabled */ }
  }, [mode]);

  return [mode, setMode];
}

export { STORAGE_KEY as EVENT_VIEW_MODE_KEY };
